import styled from 'styled-components';
import { Select } from 'antd';

export const CommonToolsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
`;

export const PercentileSelectorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StyledPercentileSelect = styled(Select)`
  width: 85px;
  text-align: center;

  .ant-select-selector {
    padding: 0 5px !important;
  }

  .ant-select-selection-item {
    padding-inline-end: 10px;
  }
`;

export const WarningIcon = styled.span`
  color: #faad14;
`;
